import { attempt } from "@omni/utils/function.utils";
import { CountryCode, parsePhoneNumber } from "libphonenumber-js";

export type PhoneNumberProps = {
    phoneNumber?: string | null;
    ISOcountryCode?: CountryCode;
    asLink?: boolean;
};

const PhoneNumber = ({
    phoneNumber,
    ISOcountryCode,
    asLink = false
}: PhoneNumberProps) => {
    if (!phoneNumber) return null;

    const parsedPhoneNumber = attempt(
        () => {
            const phoneObject = parsePhoneNumber(phoneNumber, ISOcountryCode);
            return {
                label: phoneObject.formatInternational(),
                uri: phoneObject.getURI()
            };
        },
        { label: phoneNumber, uri: `tel:${phoneNumber}` }
    );

    if (asLink) {
        return <a href={parsedPhoneNumber.uri}>{parsedPhoneNumber.label}</a>;
    }

    return <>{parsedPhoneNumber.label}</>;
};

export { PhoneNumber };
